// src/components/SettingsModalRouter.js
import React from "react";
import AccountSettings from "./settings/AccountSettings";
import SecuritySettings from "./settings/SecuritySettings";
import PrivacySettings from "./settings/PrivacySettings";
import NotificationSettings from "./settings/NotificationSettings";
import DisplaySettings from "./settings/DisplaySettings";
import ResourcesSettings from "./settings/ResourcesSettings";


const componentMap = {
  account: AccountSettings,
  security: SecuritySettings,
  privacy: PrivacySettings,
  notifications: NotificationSettings,
  display: DisplaySettings,
  resources: ResourcesSettings,
};

const SettingsModalRouter = ({ type, onClose }) => {
  const Component = componentMap[type];
  if (!Component) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg rounded-xl shadow-lg p-6 relative">
        <button
          className="absolute top-3 right-4 text-gray-600 hover:text-black text-xl font-bold"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <Component />
      </div>
    </div>
  );
};

export default SettingsModalRouter;
